import {
    SET_ALL_SELECTED,
    SET_SELECTED_IDS,
} from 'store/actions/listActions';

const initialState = {};

export default (previousState = initialState, { type, payload, meta }) => {
    switch (type) {
        // 전체 체크박스 checked/unchecked 
        case SET_ALL_SELECTED: {
            const itemType = payload.itemType;
            const checked = payload.checked;
            if( checked ) {
                return {
                    ...previousState,
                    [itemType]: payload.ids
                };
            }
            return {
                ...previousState,
                [itemType]: []
            };
        }

        // 데이타 하나의 체크박스 checked/unchecked 
        case SET_SELECTED_IDS:
            const itemType = payload.itemType;
            const selectedIndexArray = previousState[itemType] || [];
            const selectedIndex = selectedIndexArray.indexOf(payload.id);

            let newSelected = [];

            // 추가 
            if (selectedIndex === -1) {
                newSelected = newSelected.concat(selectedIndexArray, payload.id);
            // 삭제 
            } else {
                newSelected = selectedIndexArray.filter( id => id !== payload.id );
            }
            return {
                ...previousState,
                [itemType]: newSelected
            };

        // meta데이타의 popup이 아니면서 unselectAll값이 true인 경우 초기화
        default:
            if( meta && meta.unselectAll ) {
                const isPopup = meta.unselectAll.popup !== undefined ? meta.unselectAll.popup : meta.popup;
                if( !isPopup ) return initialState;
            }
            return previousState;
            //return meta && !meta.popup&& meta.unselectAll ? initialState : previousState;
    }
};